import MessageBox from './src/main.js';
export default MessageBox;



// WEBPACK FOOTER //
// ./src/components/message-box/index.js